/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "@app/axios/axiosIns";

export const getAllJobApply = createAsyncThunk(
  "jobApply/all",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/admin/career", { params });
      return response?.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const deleteJobApply = createAsyncThunk(
  "jobApply/delete",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(`/admin/career/${id}`);
      return { id, data: response?.data };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

interface JobApplyState {
  isLoading: boolean;
  formLoader: boolean;
  jobApply: any;
  allJobApply: any;
  error: any;
}
const initialState: JobApplyState = {
  isLoading: false,
  formLoader: false,
  jobApply: null,
  allJobApply: [],
  error: null,
};
export const jobApplySlice = createSlice({
  name: "jobApply",
  initialState,
  reducers: { resetState: () => initialState },
  extraReducers: (builder) => {
    builder
      .addCase(getAllJobApply.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllJobApply.fulfilled, (state, action) => {
        state.isLoading = false;
        state.allJobApply = action.payload;
      })
      .addCase(getAllJobApply.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(deleteJobApply.pending, (state) => {
        state.formLoader = true;
      })
      .addCase(deleteJobApply.fulfilled, (state) => {
        state.formLoader = false;
      })
      .addCase(deleteJobApply.rejected, (state) => {
        state.formLoader = false;
      });
  },
});
export const { resetState } = jobApplySlice.actions;
export default jobApplySlice.reducer;